import { render, staticRenderFns } from "./workBriefingDetail.vue?vue&type=template&id=1573edfe&scoped=true"
import script from "./workBriefingDetail.vue?vue&type=script&lang=js"
export * from "./workBriefingDetail.vue?vue&type=script&lang=js"
import style0 from "./workBriefingDetail.vue?vue&type=style&index=0&id=1573edfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1573edfe",
  null
  
)

export default component.exports